// ----------------------------------------------------------------------




export const account = {
  displayName: 'OES Admin',
  email: 'placedealsonkart@gmail.com',
  photoURL: '/assets/images/avatars/avatar_25.jpg',
};
